__turbopack_context__.v({
  "branding": "mobile-nav-module__R3rKDW__branding",
  "closeMobileNavBtn": "mobile-nav-module__R3rKDW__closeMobileNavBtn",
  "googleReviewButton": "mobile-nav-module__R3rKDW__googleReviewButton",
  "menuIsOpen": "mobile-nav-module__R3rKDW__menuIsOpen",
  "mobileNav": "mobile-nav-module__R3rKDW__mobileNav",
  "mobileNavBtn": "mobile-nav-module__R3rKDW__mobileNavBtn",
  "mobileNavWrapper": "mobile-nav-module__R3rKDW__mobileNavWrapper",
  "mobileNavbarActionButtons": "mobile-nav-module__R3rKDW__mobileNavbarActionButtons",
  "navLinks": "mobile-nav-module__R3rKDW__navLinks",
  "reviewBox": "mobile-nav-module__R3rKDW__reviewBox",
  "reviewButton": "mobile-nav-module__R3rKDW__reviewButton",
  "socialIcons": "mobile-nav-module__R3rKDW__socialIcons",
  "socialIconsRev": "mobile-nav-module__R3rKDW__socialIconsRev",
  "stars": "mobile-nav-module__R3rKDW__stars",
  "writeReviewContent": "mobile-nav-module__R3rKDW__writeReviewContent",
  "writeReviewInnerContainer": "mobile-nav-module__R3rKDW__writeReviewInnerContainer",
  "yelpReviewButton": "mobile-nav-module__R3rKDW__yelpReviewButton",
});
